import { Button } from 'src/common/components/Button';

// todo: Modify Buttons in code to use Button
export const ScreenScrapeButton = Button;
